import { render, staticRenderFns } from "./fileBox.vue?vue&type=template&id=e26f3490&scoped=true"
import script from "./fileBox.vue?vue&type=script&lang=js"
export * from "./fileBox.vue?vue&type=script&lang=js"
import style0 from "./fileBox.vue?vue&type=style&index=0&id=e26f3490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26f3490",
  null
  
)

export default component.exports